export default function Capitalize() {
        return function(input) {
            return input
                ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            })
                : '';
        };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/capitalizeFilter.js